import { EnvironmentProviders, Provider } from '@angular/core';
import { provideSoftAppsModule, withSoftAppsModuleTranslation } from '@softapps/core';
import { getModuleGroupByName } from '@softline/application';
import { default as de } from '../i18n/de.json';

export const rohstoffbilanzProviders: Array<Provider | EnvironmentProviders> = [
  provideSoftAppsModule(
    {
      name: '#PRODUKTION_ROHSTOFFBILANZ.TITLE',
      title: '#PRODUKTION_ROHSTOFFBILANZ.TITLE',
      icon: 'fa-regular fa-scale-balanced',
      route: '/rohstoffbilanz',
      group: getModuleGroupByName('Produktion'),
    },
    withSoftAppsModuleTranslation({ de })
  ),
];
